module.exports = __webpack_public_path__ + "static/teamup-3546f39dafd8c451cc1fc7d9e5a18285.png";